import type {ReactNode} from 'react';
import React from 'react';

import {useIsFeatureFlagEnabled} from 'client/components/FeatureFlag/featureFlag.utils';

import {useAnnotationModeStore} from './AnnotationModeStore';
import {useAnnotationsHighlights} from './useAnnotationsHighlights';

interface AnnotatableContentProps {
  questionId: string;
  children: ReactNode;
}

/**
 * Wraps children so selections inside them become highlights (see
 * `useAnnotationsHighlights`). Offsets index the rendered visible text, not the
 * source markdown — future persistence must account for that.
 */
export default function AnnotatableContent({questionId, children}: AnnotatableContentProps) {
  const {isFeatureEnabled, isLoading} = useIsFeatureFlagEnabled('student_annotations');
  const isAnnotationModeOn = useAnnotationModeStore((state) => state.isAnnotationModeOn);
  const {onMouseUp, containerRef} = useAnnotationsHighlights(questionId);

  if (isLoading || !isFeatureEnabled) {
    return <>{children}</>;
  }

  return (
    <div ref={containerRef} onMouseUp={isAnnotationModeOn ? onMouseUp : undefined}>
      {children}
    </div>
  );
}
